"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAccessDetails = void 0;
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var selectAccessDetails = function (state) {
    var perm = state.project.currentProject.status === 'FETCHED' &&
        state.project.currentProject.project.perm
        ? state.project.currentProject.project.perm & ~acl.FEATURE_MASK
        : 0x00;
    var isSuperAdmin = state.auth.current.user
        .map(function (u) { return u.level === 'SuperAdminUserGroup' || false; })
        .getOrElse(false);
    var isProjectAdmin = acl.isProjectAdmin(perm);
    var isLightAdmin = acl.isLightAdmin(perm);
    var isSokoBidAdmin = acl.isSokoBidAdmin(perm);
    var isCustomerAdmin = acl.isCustomerAdmin(perm);
    var accessFolderPermission = !!isProjectAdmin;
    var accessUserManagement = !!(isProjectAdmin ||
        isLightAdmin ||
        isSokoBidAdmin);
    return {
        isSuperAdmin: isSuperAdmin,
        isProjectAdmin: isProjectAdmin,
        isCustomerAdmin: isCustomerAdmin,
        isLightAdmin: isLightAdmin,
        isSokoBidAdmin: isSokoBidAdmin,
        accessFolderPermission: accessFolderPermission,
        accessUserManagement: accessUserManagement
    };
};
exports.selectAccessDetails = selectAccessDetails;
